"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelector = void 0;
const react_1 = __importDefault(require("react"));
const resolve_1 = require("./resolve");
const hooks_1 = require("./hooks");
const selectorCache = new WeakMap();
const createSelector = (schemaComponents) => {
    const cachedSelector = selectorCache.get(schemaComponents);
    if (cachedSelector) {
        return cachedSelector;
    }
    Object.freeze(schemaComponents);
    const resolve = (0, resolve_1.createResolver)(schemaComponents);
    const Field = (props) => {
        const { fieldPath, readOnly, control, schema, label } = props;
        const Component = resolve(schema.schemaType);
        if ((Component === null || Component === void 0 ? void 0 : Component.display) && (readOnly || schema.readOnly)) {
            return (react_1.default.createElement(Display, Object.assign({ fieldPath: fieldPath || "", component: Component.display }, props)));
        }
        else if (Component) {
            return (react_1.default.createElement(Component, { control: control, fieldPath: fieldPath || "", readOnly: readOnly || schema.readOnly, schema: schema, label: label }));
        }
        else {
            console.error("Cannot resolve schema", props);
            return react_1.default.createElement("div", null, "Cannot resolve schema");
        }
    };
    selectorCache.set(schemaComponents, Field);
    return Field;
};
exports.createSelector = createSelector;
const Display = (props) => {
    const { component: Component, schema } = props;
    const value = (0, hooks_1.useValue)(props);
    return react_1.default.createElement(Component, { value: value, schema: schema });
};
